import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import {
  FaLaptopCode,
  FaSearch,
  FaRocket,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaCheckCircle,
} from "react-icons/fa";
import "./FreelancerInVirar.css";

const services = [
  "Business Website Development",
  "React Website & Web App Development",
  "Portfolio & Personal Brand Websites",
  "Landing Page Design",
  "SEO-Friendly Website Structure",
  "Website Speed Optimization",
];

export default function FreelancerInVirar() {
  return (
    <>
      <Helmet>
        <title>
          Best Freelancer in Virar | Website Developer Near You — Amresh
          Prajapati
        </title>
        <meta
          name="description"
          content="Looking for a trusted freelancer in Virar? Amresh Prajapati builds fast, mobile-friendly, SEO-ready websites for businesses in Virar West & East. 4+ years experience. Local meetings available — get a free quote!"
        />
        <meta
          name="keywords"
          content="best freelancer in Virar, freelancer in Virar, web developer in Virar, website developer near me, React developer Virar, SEO services Virar"
        />
        <link
          rel="canonical"
          href="https://freelanceramreshprajapatimumbai.in/freelancer-in-virar"
        />
      </Helmet>

      <main className="local-page">
        <section className="local-hero">
          <div className="local-bg-glow local-bg-glow-one" />
          <div className="local-bg-glow local-bg-glow-two" />

          <div className="local-container local-hero-grid">
            <motion.div
              className="local-hero-content"
              initial={{ opacity: 0, y: 35 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <span className="local-badge">
                <FaMapMarkerAlt /> Freelancer in Virar West & East
              </span>

              <h1>
                Best Freelancer in Virar for Website Development, React Apps &
                SEO
              </h1>

              <p>
                I’m Amresh Prajapati, a freelance website developer helping
                local businesses, startups and personal brands in Virar build
                fast, modern and SEO-friendly websites that generate real
                enquiries.
              </p>

              <div className="local-hero-actions">
                <a
                  href="https://wa.me/919004068462?text=Hello%20Amresh,%20I%20am%20looking%20for%20a%20freelancer%20in%20Virar%20for%20website%20development."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="local-btn local-btn-primary"
                >
                  <FaWhatsapp /> Contact on WhatsApp
                </a>

                <Link to="/contact" className="local-btn local-btn-outline">
                  Request Quote
                </Link>
              </div>
            </motion.div>

            <motion.div
              className="local-hero-card"
              initial={{ opacity: 0, scale: 0.94 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.15 }}
            >
              <h2>Local Web Services</h2>

              <div className="local-card-list">
                <div>
                  <FaLaptopCode />
                  <span>Custom Website Development</span>
                </div>
                <div>
                  <FaRocket />
                  <span>Fast Loading & Mobile Responsive</span>
                </div>
                <div>
                  <FaSearch />
                  <span>SEO Ready Structure</span>
                </div>
              </div>

              <div className="local-location-box">
                <strong>Serving:</strong>
                <p>Virar West, Virar East, Vasai-Virar, Mumbai & nearby areas</p>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="local-section">
          <div className="local-container">
            <div className="local-section-head">
              <span>What I Do</span>
              <h2>Website Solutions for Local Businesses in Virar</h2>
              <p>
                From simple business websites to complete React-based web apps,
                I create clean, premium and conversion-focused digital
                experiences.
              </p>
            </div>

            <div className="local-services-grid">
              {services.map((item, index) => (
                <motion.div
                  className="local-service-card"
                  key={item}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.06 }}
                >
                  <FaCheckCircle />
                  <h3>{item}</h3>
                  <p>
                    Professional, responsive and SEO-focused development for
                    businesses that want better online visibility.
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="local-section local-dark-section">
          <div className="local-container local-two-col">
            <div>
              <span className="local-mini-title">Why Choose Me?</span>
              <h2>Freelance Web Developer Near You in Virar</h2>
            </div>

            <div className="local-text-box">
              <p>
                Working with a local freelancer gives you direct communication,
                faster updates and better understanding of your business goals.
                I help you plan, design and develop a website that looks
                professional and performs well on Google.
              </p>

              <ul>
                <li>Local meeting available near Virar</li>
                <li>Mobile-first responsive website design</li>
                <li>React, frontend, backend and CRM development support</li>
                <li>SEO-friendly pages for local business visibility</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="local-cta">
          <div className="local-container local-cta-box">
            <h2>Need a Website for Your Business in Virar?</h2>
            <p>
              Let’s build a modern, fast and SEO-ready website for your brand.
            </p>

            <a
              href="https://wa.me/919004068462?text=Hello%20Amresh,%20I%20need%20a%20website%20for%20my%20business%20in%20Virar."
              target="_blank"
              rel="noopener noreferrer"
              className="local-btn local-btn-primary"
            >
              <FaWhatsapp /> Start Project
            </a>
          </div>
        </section>
      </main>
    </>
  );
}